export default {
      id: "ic_caret_up_green-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_caret_up_green-usage",
      toString: function () {
        return this.url;
      }
    }